// eslint-disable-next-line import/prefer-default-export
export const QUICK_SALON_CREATION_COMPLETED = 'QUICK_SALON_CREATION_COMPLETED';
